import { useEffect } from "react";
import aiInterviewService from "../../../Services/ai-interview.service";
import { InterviewSession } from "../../../Interface/Index";
import useInterviewRoundsHandlers from "./useInterviewRoundsHandlers";


const usePing = (
  currentSession: InterviewSession,
  isRoundFinished: boolean,
  activeQuestionIndex: number
) => {
  const { handleUnqualifiedRound } = useInterviewRoundsHandlers();

  useEffect(() => {
    if (!currentSession) return;

    const interval = setInterval(async () => {
      if (
        currentSession.status === "pending" &&
        !isRoundFinished &&
        activeQuestionIndex >= 0
      ) {
        const pingResponse = await aiInterviewService.storePinginfo(
          currentSession?._id
        );
        console.log("Ping response:", pingResponse);
        if (
          pingResponse &&
          pingResponse?.isDisqualified &&
          pingResponse?.jobApplication
        ) {
          handleUnqualifiedRound(
            pingResponse.jobApplication,
            pingResponse.interviewSession
          );
        }
      }
    }, 5000);

    return () => clearInterval(interval);
  }, [currentSession, isRoundFinished, activeQuestionIndex]);
};

export default usePing;
